<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Professions</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onProfessionCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search }
      </button>
      <button mat-raised-button color="primary" (click)="onCreateProfession()">
        <mat-icon>add</mat-icon>
        Add Profession
      </button>
    </div>
  </div>
  <app-lookup-table-search-box
    [isSearchVisible]="isSearchVisible"
    (searchFilter)="onSearchFilterChange($event)">
  </app-lookup-table-search-box>
  <app-lookup-table
      [items]="professions()"
      [enableMatching]="true"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditProfession($event)"
      (deleteClick)="onDeleteProfession($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
